import { render, staticRenderFns } from "./DealDialog.vue?vue&type=template&id=d21768be&scoped=true&"
import script from "./DealDialog.vue?vue&type=script&lang=js&"
export * from "./DealDialog.vue?vue&type=script&lang=js&"
import style0 from "./DealDialog.vue?vue&type=style&index=0&id=d21768be&scoped=true&lang=css&"
import style1 from "./DealDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21768be",
  null
  
)

export default component.exports